export default __webpack_public_path__ + "static/media/DtVkJx26TKEr37c9aBBxbl8c_SjTjQJElti5.a5495a3f.woff2";